module.exports = __webpack_public_path__ + "static/img/6.0925d57.png";


//////////////////
// WEBPACK FOOTER
// ./static/images/products/5/8/1/eng/6.png
// module id = s9rH
// module chunks = 0